import axios, {keycloak} from '@/api'

export default {
  fetchZones({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/zones/',{params: {limit: 4000, ...payload}})
        .then((response) => {
          commit('SET_ZONES', response.data.zones)
          resolve(response.data.zones)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  getZones({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/zones/',{params: payload})
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  storeZone({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.post('/admin/zones/', payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  getZone({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/zones/'+payload.id+'/')
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => { reject(error.response) })
    })
  },
  updateZone({ commit }, payload){
    return new Promise((resolve, reject) => {
      let url = '/admin/zones/'+payload.id+'/';
      delete payload.id;

      axios.put(url, payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  deleteZone({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.delete('/admin/zones/'+payload.id+'/')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },

  fetchPartnerZones({ commit },payload){
    return new Promise((resolve, reject) => {
      delete payload.partner_id;
      axios.get(`/admin/partners/zones/`,{params:  payload})
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  getPartnerZones({ commit },payload){
    return new Promise((resolve, reject) => {
      delete payload.partner_id;
      axios.get(`/admin/partners/zones/`,{params:  payload})
        .then((response) => {
          commit('SET_ZONES', response.data.zones)
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
}
